import { render, staticRenderFns } from "./CabeceraIndicador.vue?vue&type=template&id=206d3122&"
import script from "./CabeceraIndicador.vue?vue&type=script&lang=js&"
export * from "./CabeceraIndicador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports